export default function HintsPage() {
  return (
    <main className="min-h-screen bg-black text-white">
      <section className="max-w-5xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold mb-4">Hints</h1>
        <p className="text-white/80 mb-8">Tiered hints to guide you without spoilers.</p>
        <a href="/" className="inline-block rounded-xl px-5 py-3 border border-white/20 hover:border-white/40">
          ← Back to Home
        </a>
      </section>
    </main>
  );
}

